import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import { UserserviceService } from '../userservice.service';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpClient} from '@angular/common/http';


@Component({
  selector: 'app-apply-new-migration-certificate',
  templateUrl: './apply-new-migration-certificate.component.html',
  styleUrls: ['./apply-new-migration-certificate.component.scss']
})
export class ApplyNewMigrationCertificateComponent implements OnInit {
  public formControl = new FormControl();
  Requestform!:FormGroup;
  paymentform!: FormGroup;
 // paymentform1!: FormGroup;
  studData:any
  updatesuccess: number=0;
   showDiv = {
   previous : true,
   next : false,
  }
  showinfoofteacher=false;
  mobnumberofteacher: string = '';
  teacherInfo!:any;

  // isactive1:boolean=true;
  // isactive2:boolean=false;
  // isactive3:boolean=false;
  // isactive4:boolean=false;

  tab1cont:boolean=true;
  tab2cont:boolean=false;
  tab3cont:boolean=false;
  tab4cont:boolean=false;
  tab5cont:boolean=false;
  tab6cont:boolean=false;

  // try
  alltabclasses = [
      {
        tab1cont:true,
        tab2cont:false,
        tab3cont:false,
        tab4cont:false,
        tab5cont:false,
        tab6cont:false
      }
  ];
  loginform!: FormGroup;
  loading = false;
  submitted = false;
  isShow!: boolean;
  paymentmsg: any;
  isChecked!: boolean;
  loginusername: any;
  feesData:any;
  formdisable:boolean=true;
  isuuemode: any;
  deliverymode: any;
  fees: any;
  feesData1: any;
  fees1: any;
  total_fees: any;
  application_type_requested: any;
  file_photo:any='';
  file_marksheet:any='';
  paymenturl: any;
  proccessing:boolean=false;
  transid: any;
  selectedstandard: any;
  photoinfo: any="";
  marksinfo: any="";
  validstudent:any;
  disabledflagnoninvalid!: boolean;
  displayStyle: any="none";
  failstudentmsg: string="";
  verified_name: any="";
  certificate_data: any;
  selectedPaymentMode: any;
  errorMsg: any;
  isChecked1!: boolean;
  isChecked2!: boolean;
  attachedphoto!: boolean;
  attachedphotomsg: string="";
  attachedmarksheet!: boolean;
  correctNameAsPerMarksheet: any;
  constructor(private service:UserserviceService ,public router: Router,private httpClient: HttpClient,private route: ActivatedRoute,private formBuilder: FormBuilder) 
  {
   
  }

  ngOnInit(): void {
    if(sessionStorage.getItem('roleid')=="1" && sessionStorage.getItem('loggedapptype')=="Fresh_Migration_Certificate"){      
      if(!sessionStorage.getItem("loggeduser") || sessionStorage.getItem("loggeduser")==null){
         this.router.navigate(['/dashboard']);
        // sessionStorage.clear();
       }
      
      else{
          // this.proceed();
          this. getStudDetail();
          this.Requestform = this.formBuilder.group({
          
            // saluation:['',Validators.required],
            stud_name:['',Validators.required],
            standard:['',Validators.required],
            mobile_no:['',[Validators.required, Validators.pattern("^((\\+91-?)|0)?[0-9]{10}$")]],     
            email_address:['',[Validators.required,Validators.email,Validators.pattern('^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$')]],
            address:['',Validators.required],
            pincode:['',Validators.required],
            exam_month_year:['',Validators.required],
            // passing_month_year:['',Validators.required],
            seat_no:['',Validators.required],
            school_name:['',Validators.required],
            upload_photo:['',Validators.required],
            upload_marksheet:['',Validators.required],
            // application_type:['',Validators.required],
            // certificate_delivery_mode:['',Validators.required],
          //  certificate_delivery_mode:[''],
            //application_create_date:[''],	
            //payment:[''],
            //extra_charges_pay:[''],
            //total_payment:[''],
            //pay_using:[''],
          //payment_status:['']
            
          })
          this.paymentform = this.formBuilder.group({ 
            certificate_delivery_mode:[''],          
            application_type:[''],	
            payment:[''],
            extra_charges_pay:[''],
            total_payment:[''],
        // pay_using:[''],
      // payment_status:['']
      })
      }
    }
    else{
      this.router.navigate(['/dashboard']);
    }
       
      
}
     
  
  get f() { return this.Requestform.controls; 
     }
  getphoto(event:any){
    const fileList: FileList = event.target.files;
    //check whether file is selected or not
    if (fileList.length > 0) {
        const file = fileList[0];
      if((file.size/1048576)<=4)
        {
          let formData = new FormData();
          formData.append('photofile', file, file.name);
         this.file_photo=event.target.files[0];
        //  console.log(file.name);
        //  this.photoinfo=event.target.value; 
        this.attachedphoto=true;
        this.attachedphotomsg=file.name;
        }   
      }
      else{
        this.attachedphoto=false;
        this.attachedphotomsg="";
      } 
      // console.log(this.file_photo); 
    }
    getmarksheet(event:any){
      const fileList: FileList = event.target.files;
      //check whether file is selected or not
    if (fileList.length > 0) {
        const file = fileList[0];
         if((file.size/1048576)<=4)
        {
          let formData = new FormData();
          // let info={id:2,name:'raja'}
          formData.append('marksheetfile', file, file.name);
          this.file_marksheet=event.target.files[0];
          // this.marksinfo=event.target.files[0]; 
          this.attachedmarksheet=true;
        }   
      } 
      else{
        this.attachedmarksheet=false;       
      }  
      
  }
  onSubmit(form:any){
    // const controls = this.Requestform.controls;
    //   for (const name in controls) {
    //       if (controls[name].invalid) {
    //           console.log(name);
    //       }
    //   }
      this.submitted = true;
      if (this.Requestform.invalid) {
        alert("Please Fill all details from all tabs!!");    
        this.displayStyle = "none";
        return;
      }
      else  if(this.disabledflagnoninvalid){
        alert("Please Enter Valid details of Last Exam in Educational Details tab! ");
        this.displayStyle = "none";
        let e:{id:any}={id:"tab2"};   
        this.gotopage(e);   
      }
      else{
        this.updatestuddetails();
        // setTimeout(() => {
          this.displayStyle = "block";          
        // }, 1000);
      }
      // this.getpaymentdone();
        
    
  }

  getStudDetail(){
    this.proccessing=true;
    let getstud:{ user_id:any,email_address:any}={
      user_id: sessionStorage.getItem('loggeduserid'),
      email_address: sessionStorage.getItem('loggeduser')

    };
      this.service.post('/Student_module/getregistration',getstud).subscribe((res:any)=>{
        if(res.status=="success"){
         
         setTimeout(()=>{
              if(res.Data[0].request_status!="New"){  
              alert("You have already requested for: "+res.Data[0].application_type.replace(/_+/g," "));
              this.studData="";
              this.router.navigate(['/viewapplicationstatus']);
            }
            else{
              this.studData=res.Data[0];         
              this.application_type_requested=this.studData.application_type;
            }
            if(this.studData){
              // this.Requestform.controls['saluation'].setValue(this.studData.saluation);
              this.Requestform.controls['stud_name'].setValue(this.studData.stud_name);
              this.Requestform.controls['standard'].setValue(this.studData.standard);
              this.selectedstandard=this.studData.standard;
              this.Requestform.controls['mobile_no'].setValue(this.studData.mobile_no);
              this.Requestform.controls['email_address'].setValue(this.studData.email_address);
              this.Requestform.controls['address'].setValue(this.studData.address);
              this.Requestform.controls['pincode'].setValue(this.studData.pincode);             
              this.Requestform.controls['exam_month_year'].setValue(this.studData.exam_month_year);
              // this.Requestform.controls['passing_month_year'].setValue(this.studData.passing_month_year);
              this.Requestform.controls['seat_no'].setValue(this.studData.seat_no);
              this.Requestform.controls['school_name'].setValue(this.studData.school_name);
              this.paymentform.controls['application_type'].setValue(this.studData.application_type);
              if(!(this.studData.upload_photo=="" || this.studData.upload_photo== null || this.studData.upload_photo==undefined)){
                this.photoinfo=this.studData.upload_photo; 
                this.Requestform.controls['upload_photo'].clearValidators();
                this.Requestform.controls['upload_photo'].updateValueAndValidity();
              }
              if(!(this.studData.upload_marksheet=="" || this.studData.upload_marksheet== null || this.studData.upload_marksheet==undefined)){
                this.marksinfo=this.studData.upload_marksheet;
                this.Requestform.controls['upload_marksheet'].clearValidators();
                this.Requestform.controls['upload_marksheet'].updateValueAndValidity();
              }          
            } 
              this.proccessing=false;
         },1000); 
       
      }
        else{
          this.studData="";
          alert("Page is having problem in loading, Please retry!")
          this.router.navigate(['/dashboard']);
        }
          
      });
    //get student deatils in studData variable
    
}

  proceed(tmob:any)
  {
    this.Requestform.value.mobile=tmob;
    // seacrch info api display info in personal info
    this.showDiv.next = !this.showDiv.next;
    this.showDiv.previous = false; // if result not found add just in else part
    let ct="tab1";
    // for(let i=0;i<5;i++){
    //   if(ct=

    // }
  }
  showinfoabtteacherbtn(tmob:any){
    // this.showinfoofteacher=true;
    this.showinfoabtteacher(tmob);
  }
  showinfoabtteacher(tmob:any){ 
    let mobile :{mobile:any}={
      mobile:tmob
    }	
  }
  //tab working
  gotopage(e:any){
    // alert(e.id);
    if(e.id=="tab1")
    {
      this.tab1cont=true;
      this.tab2cont=false;
      this.tab3cont=false;
      this.tab4cont=false;
      this.tab5cont=false;
      this.tab6cont=false;
    }
    if(e.id=="tab2")
    {
      this.tab2cont=true;
      this.tab1cont=false;
      this.tab3cont=false;
      this.tab4cont=false;
      this.tab5cont=false;
      this.tab6cont=false;
    }
    if(e.id=="tab3")
    {
      this.tab3cont=true;
      this.tab2cont=false;
      this.tab1cont=false;
      this.tab4cont=false;
      this.tab5cont=false;
      this.tab6cont=false;
    }
    if(e.id=="tab4")
    {
      this.tab4cont=true;
      this.tab2cont=false;
      this.tab3cont=false;
      this.tab1cont=false;
      this.tab5cont=false;
      this.tab6cont=false;
    }
    if(e.id=="tab5")
    {
      this.tab5cont=true;
      this.tab2cont=false;
      this.tab3cont=false;
      this.tab4cont=false;
      this.tab1cont=false;
      this.tab6cont=false;
    }
    if(e.id=="tab6")
    {
      this.tab6cont=true;
      this.tab2cont=false;
      this.tab3cont=false;
      this.tab4cont=false;
      this.tab5cont=false;
      this.tab1cont=false;
    }
}

opennexttab(currtab:any){
  //tab1cont
    let ctab= currtab.slice(0,currtab.indexOf('cont'));
    let jumpto=parseInt(ctab.substr(ctab.length -1));
    let nxttab:{id:any}={
      id:"tab"+ ++jumpto
    }
    // alert(nxttab.id);
    this.gotopage(nxttab);
}
openpretab(currtab:any){
  //tab1cont
    let ctab= currtab.slice(0,currtab.indexOf('cont'));
    let jumpto=parseInt(ctab.substr(ctab.length -1));
    let nxttab:{id:any}={
      id:"tab"+ +jumpto
    }
    // alert(nxttab.id);
    this.gotopage(nxttab);
}
updatestuddetails(){
  let exam_center;
  let exam_month_year;
  // console.log(this.certificate_data);
  if(this.certificate_data){
  if(this.Requestform.value.standard=="HSSC"){
    exam_center=this.certificate_data.centre;
    exam_month_year=this.certificate_data.exam;
  }
  else{
    exam_center=this.certificate_data.cname;
    exam_month_year=this.certificate_data.monthyear;  
  }
  }else{
    exam_center="";
    exam_month_year=this.Requestform.value.exam_month_year;  
  }
  let studdetail = new FormData;
  studdetail.append('stud_name',this.Requestform.value.stud_name); 
  // studdetail.append('saluation',this.Requestform.value.saluation);
  studdetail.append('standard',this.Requestform.value.standard);
  studdetail.append('mobile_no',this.Requestform.value.mobile_no);
  studdetail.append('email_address',this.Requestform.value.email_address); 
   studdetail.append('address',this.Requestform.value.address);
   studdetail.append('pincode',this.Requestform.value.pincode);
  //  studdetail.append('passing_month_year',this.Requestform.value.passing_month_year); 
  studdetail.append('seat_no',this.Requestform.value.seat_no);
  studdetail.append('school_name',this.Requestform.value.school_name); 
  studdetail.append('application_type',this.paymentform.value.application_type);
  //  studdetail.append('certificate_delivery_mode',this.paymentform.value.certificate_delivery_mode);
  studdetail.append('certificate_delivery_mode',this.deliverymode);
  //  studdetail.append('payment',this.paymentform.value.payment);
  studdetail.append('payment',this.feesData);
  //  studdetail.append('extra_charges_pay',this.paymentform.value.extra_charges_pay);
  studdetail.append('extra_charges_pay',this.feesData1);
  //  studdetail.append('total_payment',this.paymentform.value.total_payment);
  studdetail.append('total_payment',this.total_fees);
  studdetail.append('verified_name',this.verified_name);
  studdetail.append('original_first_name',this.correctNameAsPerMarksheet);
   studdetail.append('exam_month_year',this.Requestform.value.exam_month_year);
//data from certificate table
   studdetail.append('exam_month_year',exam_month_year);
   studdetail.append('exam_center',exam_center);
  if(this.file_photo!=""){
      studdetail.append('upload_photo',this.file_photo,this.file_photo.name);
    }
   if(this.file_marksheet!=""){
     studdetail.append('upload_marksheet',this.file_marksheet,this.file_marksheet.name);
   }
   
  //  studdetail.append('pay_using',"UPI");
  //  studdetail.append('payment_status',"succsess");
  //  studdetail.append('transaction_id',"1000000");
  //  console.log(studdetail);
  this.service.post('/Student_module/addapplicationrequest',studdetail).subscribe((res:any)=>{
    console.log(res);
   if(res.status=="success"){
      console.log(res.Data);
      //  console.log("student details updated!")
       this.updatesuccess=1;
      //  alert(this.Requestform.value.exam_month_year.substr(this.Requestform.value.exam_month_year.length - 4));
       if(this.Requestform.value.exam_month_year.substr(this.Requestform.value.exam_month_year.length - 4)<2011){
          alert(res.Data+"\r\n ");        
       }
      //  this.router.navigate(['/viewapplicationstatus'])
      //  window.location.reload();
      //     console.log("student details updated!");
   }
   else{
    this.errorMsg=res.Data;
    this.updatesuccess=0;
   }
      

 });
 }
 

    getfees(delmode:any){
      // alert( "getfees");
      // alert(this.application_type_requested);
      let appl:{application_type_requested:any}={
        application_type_requested:this.application_type_requested
      }
       this.service.post('/Student_module/getfees',appl).subscribe((res:any)=>{
        if(res.status=="success"){
          if(delmode=="by_person" ){
              this.feesData=res.Data[0].basic_certificate_fees; 
              this.feesData1=0;
              this.total_fees=Number(this.feesData)+Number(this.feesData1);
            
          }
          else{
              this.feesData=res.Data[0].basic_certificate_fees; 
              this.feesData1=res.Data[0].postal_fees;
              this.total_fees=Number(this.feesData)+Number(this.feesData1);
          }
          // this.paymentform.controls['total_payment'].setValue(this.total_fees);
           }
           else{
             alert("Page is having problem in loading, PLease reload page.");
              // window.location.reload();
           }
        });
    
  }
 

  toggleDisplay(e:any) {
     this.getfees(e.value); 
    if(e.value=="by_person" ){
     this.paymentmsg="Board Will inform you date and time to collect."
      this.isShow = true;
      this.isChecked1 = true;
     this.deliverymode=e.value;
     if(this.isChecked1 && this.isChecked2){
        this.isChecked=true;
      }
      else{
        this.isChecked=false;
      }
    }
    else if(e.value=="by_post" ){
       this.paymentmsg="Extra Charges will be applied as per distance."
      this.isShow = true;
      this.isChecked1 = true;
      this.deliverymode=e.value;
      if(this.isChecked1 && this.isChecked2){
        this.isChecked=true;
      }
      else{
        this.isChecked=false;
      }
    }
    else{
      this.paymentmsg=""
      this.isShow =false;
      this.deliverymode="";
      
    }
  }

  submit(){//for students after 2013
    alert('Your request will be processed within 48 hours after acceptance')
  }

  //payment 
  paymentdetails(payform:any){
    // alert("Your Info is saved! Payemnt Page will loaded here");
    this.closePaymentmodal();
    if(this.updatesuccess==1){
      this.getpaymentdone();
    }
    else{
      alert(this.errorMsg+"\n Your Information Not Got saved due to some reason, \n Please try again!");
      // window.location.reload();
    }
      
  }

  getpaymentdone(){
    // let studdetails:{user_id:any,payment_amt:any,payment_mode:any}={
    //   user_id:sessionStorage.getItem('loggeduserid'),
    //   payment_mode:9,
    //   payment_amt:this.total_fees,
    // }
    let studdetails:{user_id:any,payment_amt:any,payment_mode:any,application_id:any,submerchantid:any,PayerName:any,email_address:any,mobile_no:any}={
      user_id:sessionStorage.getItem('loggeduserid'),
      payment_mode:this.selectedPaymentMode,
      payment_amt:this.total_fees,
      application_id:this.studData.application_id,
      PayerName:this.studData.stud_name,
      email_address:this.studData.email_address,
      mobile_no:this.studData.mobile_no,
      submerchantid:'6080'
    }

   
    this.service.post('/Icicipayment/getPaymentUrl',studdetails).subscribe((res:any)=>{
      if(res.status=="success"){
          this.paymenturl=res.url;
          this.transid=res.transactionid;
          sessionStorage.setItem('flgrep','true');
          console.log(this.paymenturl);
          window.open(this.paymenturl,"_self");
      }
      else{
        alert("Not able to proceed for payment! Please try again!!");
        this.router.navigate(['/viewapplicationstatus']);
      }
    
    });
  }
//varify if student is of GBSHSE
  // varifypayment(){
  //   let studdetails:{transactionid:any}={
  //     transactionid:this.transid     
  //   }
  //   this.service.post('/Icicipayment/verifyIcicipayment',studdetails).subscribe((res:any)=>{
  //     // console.log(res);
  //         if(res.status=="success"){
              
  //         }
        
  //       });
  // }
  checkifstudentisvalid(){// fun on change of educational details

        if(this.Requestform.value.exam_month_year==" "||
        this.Requestform.value.exam_month_year==null|| 
        this.Requestform.value.seat_no==" " ||
        this.Requestform.value.seat_no==null ||
        this.Requestform.value.school_name ==" " ||
        this.Requestform.value.school_name ==null){
          // alert("Please fill \'Exam Month and year\' and \'Seat\' No and \'School Index\' ");
          // let e:{id:any}={id:"tab2"};   
          // this.gotopage(e);  
        }
        else{
          if(this.Requestform.value.exam_month_year.substr(this.Requestform.value.exam_month_year.length - 4)<2011){
              this.validstudent="";
              this.disabledflagnoninvalid=false;
              this.failstudentmsg="";
              this.certificate_data="";
          }
          else{      // api to check valid student and result
          let getstud: { seat:any, exam:any,scode:any,standard:any}={
            seat :this.Requestform.value.seat_no,
            exam: this.Requestform.value.exam_month_year, 
            scode:this.Requestform.value.school_name,
            standard:this.Requestform.value.standard
          };
          
          this.service.post('/Boardadmin_module/verifySeatno',getstud).subscribe((res:any)=>{
            
            if(res.status=="success"){
                // if(res.Data=="Details will be evaluated mannualy"){
                //   this.validstudent="";
                //   this.disabledflagnoninvalid=false;
                //   this.failstudentmsg="";
                // }
                // else
                this.certificate_data=res.Data[0];
                if(res.Data[0].result=="PASSES"){
                  this.validstudent="./assets/img/checkmarksuccess.gif";
                  this.disabledflagnoninvalid=false;
                  this.failstudentmsg="";
                }
                else{
                  this.disabledflagnoninvalid=true;
                  this.validstudent="./assets/img/errormark.gif";
                  this.failstudentmsg="Your result is not PASS You will Not be able to submit this application.";
                  alert("To fill this application, Your result should  have to be 'PASS'");
                }  
                if(res.Data[0].stname.toUpperCase()!=this.Requestform.value.stud_name.toUpperCase()){
                    alert("Entered Name is not as per School Data");
                    this.verified_name="not as per data";
                    this.correctNameAsPerMarksheet=res.Data[0].stname;
                  } 
                  else{
                    // alert("Entered Name is as per School Data");
                    this.verified_name="Varified";
                    this.correctNameAsPerMarksheet=res.Data[0].stname;
                }
            }
            else{
              //  alert(res.Data);
              this.disabledflagnoninvalid=true;
              this.validstudent="./assets/img/errormark.gif";
              this.failstudentmsg="You will Not be able to submit this application, Reason: No Data Found";
              alert("Your details are not matching with school data. \n OR \n Enter correct data in Month and Exam");
            }
              
          });
            // if(this.disabledflagnoninvalid){
            //   this.validstudent="../.../assets/img/errormark.gif";
            // }else{                
            //   this.validstudent="../.../assets/img/checkmarksuccess.gif";
            // }
            


          }
        }
    
      
  }

  checkstudvalid(){

   
     this.onSubmit(this.Requestform.value);

    // if(this.disabledflagnoninvalid){
    //   alert("Please Enter Valid details of Last Exam in Educational Details tab! ");
    //   this.displayStyle = "none";      
    // }
    // else{
    //   this.displayStyle = "block";
    // }
  }
  closePaymentmodal(){
    this.displayStyle="none";
    
    // alert("Your request is submitted, \nPayment is aborted by User,\n You can Pay throught View Application Status Menu !");
    // this.router.navigate(['/viewapplicationstatus']);
  }
  getpaymentmode(e:any){
    this.selectedPaymentMode=e.value;
    this.isChecked2=true;
    if(this.isChecked1 && this.isChecked2){
      this.isChecked=true;
    }
    else{
      this.isChecked=false;
    }
}
}

